module.exports = __webpack_public_path__ + "img/icon_all_history_white.61709a2e.svg";